import { render, staticRenderFns } from "./AlgoliaSearchBar.vue?vue&type=template&id=d016e7a6&"
import script from "./AlgoliaSearchBar.vue?vue&type=script&lang=js&"
export * from "./AlgoliaSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./AlgoliaSearchBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports